<template>
  <div class="pageheader">
    <div class="header">
      <div :class="{'linkMenuu': true, 'active': active === 0}" @click="$router.push({ name: 'Home' })">首页</div>
      <div :class="{'linkMenuu': true, 'active': active == 8}" @click="$router.push({ name: 'survey' })">中心概况</div>
      <!-- <div :class="{'linkMenuu': true, 'active': active == 6}" @click="$router.push({ name: 'infoDelivery' })">信息发布</div> -->
      <div :class="{'linkMenuu': true, 'active': active === 1}" @click="$router.push({ name: 'xinwen' })">中心新闻</div>
      <div :class="{'linkMenuu': true, 'active': active === 9}" @click="$router.push({ name: 'notice' })">通知公告</div>
      <!-- <div :class="{'linkMenuu': true, 'active': active === 2}" @click="$router.push({ name: 'rulers' })">规章制度</div> -->
      <div :class="{'linkMenuu': true, 'active': active === 3}" @click="$router.push({ name: 'Instrument' })">仪器设备</div>
      <div :class="{'linkMenuu': true, 'active': active === 4}" @click="$router.push({ name: 'wendang' })">文档下载</div>
      <div :class="{'linkMenuu': true, 'active': active === 10}" @click="$router.push({ name: 'userGuide' })">用户指南</div>
      <div :class="{'linkMenuu': true, 'active': active === 5}" @click="$router.push({ name: 'contact' })">联系我们</div>
      <!-- <div :class="{'linkMenuu': true, 'active': active === 7}" @click="$router.push({ name: 'login' })">预约入口</div> -->
    </div>
    <!-- <div class="breadcrumbBox">
      <span class="breadText">当前位置：</span>
      <a-breadcrumb separator=">">
        <a-breadcrumb-item v-for="(item, i) in breadList" :key="i">
          <router-link v-if="item.name != name" :to="{ path: item.path }">
            {{ item.meta.title }}
          </router-link>
          <span v-else>{{ item.meta.title }}</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div> -->
  </div>

</template>

<script>
  export default {
    data() {
      return {
        breadList: this.$route.matched,
        active: undefined
      }
    },
    watch: {
      $route: {
        handler(val) {
          this.getBreadList()
          this.getActive()
        },
        immediate: true
      }
    },
    created() {},
    methods: {
      getBreadList() {
        let breakList = []
        this.$route.matched.forEach((item, i) => {
          if (i == 0) item.path = '/home'
          if (i == 1) return
          breakList.push(item)
        })
        this.breadList = breakList
      },
      getActive() {
        let title = this.$route.meta.title
        switch (title) {
          case '首页':
            this.active = 0
            break
          case '中心新闻':
            this.active = 1
            break
          case '规章制度':
            this.active = 2
            break
          case '仪器列表':
            this.active = 3
            break
          case '文档下载':
            this.active = 4
            break
          case '联系我们':
            this.active = 5
            break
          case '信息发布':
            this.active = 6
            break
          case '预约入口':
            this.active = 7
            break
          case '中心概况':
            this.active = 8
            break
          case '通知公告':
            this.active = 9
            break
          case '用户指南':
            this.active = 10
            break
          default:
            let flag = this.$route.matched.some(item => item.meta.title == '开放仪器')
            if (flag) this.active = 3
            else this.active = undefined
            break;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .pageheader {
    width: 100%;
    // background-color: #0689DB;
    background-color: rgb(0,78,161);
    .header {
      width: 1200px;
      margin: 0 auto;
      height: 40px;
      display: flex;
      align-items: center;

      .linkMenuu {
        // padding: 0 34px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        user-select: none;
        cursor: pointer;
        font-size: 17px;
        width: 130px;
      }
    }

    .active {
      background-color: rgb(86,138,189);
    }

    .breadcrumbBox {
      width: 1376px;
      margin: 10px auto;
      text-align: left;
      display: flex;

      .breadText {
        color: #999;
      }
    }
  }
</style>